<template>
  <div>
    <p>{{ label }} data submission for <strong>{{ details.DataSource.name }} ({{ details.DataSource.type }})</strong> on {{ formatDate(details.as_of) }} (<a :href="link">Participant Data</a>)</p>
    <div class="table-responsive object-details">
      <table class="table table-striped table-hover table-sm w2h-admin-list">
        <thead>
        <tr>
          <th>Export tag</th>
          <th>Question text</th>
          <th>Response</th>
          <th>Decoded Response</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="field in details.fields" class="w2h-admin-row">
          <td>{{ field.field }}</td>
          <td>{{ field.label }}</td>
          <td>
            <img v-if="hasImage(field)" class="img-thumbnail" style="max-width: 110px" :src='field.value'>
            <template v-else>{{ field.value }}</template>
          </td>
          <td>
            <img v-if="hasImage(field)" class="img-thumbnail" style="max-width: 110px" :src='field.decoded_value'>
            <template v-else>{{ field.decoded_value }}</template>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import dayjs from 'dayjs';

  export default {
    name: "aFormSubmission",
    props: {
      details: {
        type: Object,
        default: function () {
          return {};
        }
      },
      label: {
        type: String,
        default: "Related to"
      }
    },
    inject: ['participantId'],
    computed: {
      link() {
        return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/participants/${this.participantId}/data?source_id=${this.details.source_id}`;
      }
    },
    methods: {
      hasImage(field) {
        if (!field.decoded_value) {
          return false;
        }
        const decodedValue = field.decoded_value.toString();
        return decodedValue.includes('data:image');
      },
      formatDate(date) {
        return dayjs(date).format('MM/DD/YY hh:mm A');
      },
    }
  }
</script>

<style scoped>
  .table-responsive {
    width: calc(100% - 20px);
  }
</style>